import { BrowserRouter, Route, Routes } from 'react-router-dom'

import LandingPage from '../pages'
import GalleryPage from '../pages/gallery'

import ScrollToTop from '../utils/scrollToTop'

function AppRouter() {
	return (
		<BrowserRouter>
			<ScrollToTop />
			<Routes>
				<Route path='/' element={<LandingPage />} />
				<Route path='/gallery' element={<GalleryPage />} />
			</Routes>
		</BrowserRouter>
	)
}

export default AppRouter
